import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/browser';
import { connect } from 'react-redux';
import { FAILURE } from 'utils/constants/queryStatuses';
import ServerDown from 'components/ServerDown';
import { clearAuthDataInLocalStorage } from 'functions/clearAuthDataInLocalStorage';
import { selectAppStatus } from 'modules/appStatus/appStatus.selectors';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });

    clearAuthDataInLocalStorage();

    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });

      Sentry.captureException(error);
    });
  }

  render() {
    const { appStatus, serverStatus } = this.props;

    if (this.state.error || appStatus?.status === FAILURE || serverStatus.error) {
      return <ServerDown />;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  appStatus: PropTypes.shape({
    status: PropTypes.string.isRequired,
  }),
  serverStatus: PropTypes.shape({
    error: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  appStatus: selectAppStatus(state),
  serverStatus: state.serverStatus,
});

export default connect(mapStateToProps)(ErrorBoundary);
